import { Category } from "../model/types";

const ROOT = "/terminal-management";
const ROOT_PATH = `${ROOT}/:category?/:tab?`;

export const TERMINAL_MANAGEMENT_ROUTES = {
  TERMINAL_STOPS: ROOT_PATH,
  SHIPMENTS: `${ROOT_PATH}/:terminalStopId/shipments`,
  TERMINAL_UNCLEAR_SHIPMENTS: `${ROOT}/unclear-shipments`,
} as const;

export type TerminalManagementRoute = keyof typeof TERMINAL_MANAGEMENT_ROUTES;

export type TerminalManagementParams = {
  category?: Category;
  tab?: string;
  terminalStopId?: string;
  terminalActivityId?: string;
  discussionId?: string;
};

export const FOCUSED_ACTIVITY_SEARCH_PARAM = "activityId";
